import { render, staticRenderFns } from "./UpdateInputData.vue?vue&type=template&id=98703368"
import script from "./UpdateInputData.vue?vue&type=script&lang=js"
export * from "./UpdateInputData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports